import DatesheetPage from './DatesheetPage';
const TeacherDatesheet = () => <DatesheetPage isAdmin={false} />;
export default TeacherDatesheet;